import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  mainFilterLoading: false,
};

const prepaidEngine = createSlice({
  name: 'prepaidEngine',
  initialState,
  reducers: {
    setMainFilterLoading(state, action: PayloadAction<boolean>) {
      state.mainFilterLoading = action.payload;
    },
  }
});

export const { setMainFilterLoading } = prepaidEngine.actions;
export default prepaidEngine.reducer;
